// Klartext-Stand des Kostenvoranschlags (Alt-Parität). 'approved' ist terminal (GoBD-gesperrt, kein
// erneutes Senden). Geteilt zwischen dem Auftrags-Detail (Statusanzeige) und der KV-Vorschau.
export const ESTIMATE_LABEL: Record<string, string> = {
  none: 'Noch nicht versendet',
  sent: 'Versendet – wartet auf Freigabe',
  approved: 'Vom Kunden freigegeben',
  declined: 'Vom Kunden abgelehnt',
}
